import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import {merge, pick, isEmpty, omit } from 'lodash';

import * as companyApi from '../../../redux/actionCreators/async/companies';
import {updateCompanyContacts} from '../../../redux/actionCreators/sync/companies';
import * as syncActions from '../../../redux/actionCreators/sync';

import { validate, validateField } from '../../../modelValidator';
import ScrollColumn from '../../../common/components/ScrollColumn';
import TextField from '../../../common/components/c_TextField';
import RaisedButton from '../../../common/components/c_RaisedButton';
import MaskedTextField from '../../../common/components/c_MaskedTextField';
import DropDownMenu from '../../../common/components/c_DropDownMenu';
import InfoModal from '../../../common/components/f_InfoModal';
import SimpleDropDownMenu from '../../../common/components/SimpleDropDownMenu';

@connect((store) => (
    {
      user: store.user,
      company: store.contactProfile.company,
      staticData: store.staticData,
      companyContacts: store.companyContacts
    }
  )
)
export default class CreateCompanyContact extends Component {
  static propTypes = {
    dispatch : PropTypes.func.isRequired,
    user: PropTypes.object,
    staticData: PropTypes.object.isRequired,
    companyContacts: PropTypes.object.isRequired,
    company: PropTypes.object.isRequired,
  }


  constructor(props, context) {
    super(props, context);

    this.state = {
      company: {},
      isDirty: false,
      newContactModel: {
        companyId: this.props.user.companyId, // adding required fields for user model
        department: this.props.user.department,
        cellPhone: this.props.user.cellPhone,
        workTypeDescription: this.props.user.workTypeDescription,
        address: this.props.company.address,
        city: this.props.company.city,
        state: this.props.company.state,
        zip: this.props.company.zip,
      },
      showModal: false,
      modalMessage: ''
    };
    this.addNewContactModel = {
      firstName :{
        required :{
          message :'This field is required.'
        }
      },
      lastName :{
        required :{
          message :'This field is required.'
        }
      },
      title :{
        required :{
          message :'This field is required.'
        }
      },
      phoneNumber1 :{
        required: {
          message: 'This field is required.'
        },
        isLength: {
          options: {min: 10, max: 10},
          message: 'Must be 10 digits'
        },
        isNumeric: {
          message: 'Must be numeric'
        },
        matches: {
          options: /^[2-9]\d{9}$/,
          message: 'Must be a valid phone number.'
        }
      },
      email :{
        required :{
          message :'This field is required.'
        },
        isEmail: {
          message: 'Must be a valid email.'
        }
      },
      address: {},
      city: {
        required: {
          message: 'This field is required.'
        }
      },
      state: {
        required: {
          message: 'This field is required.'
        }
      },
      zip: {},
      types : {}
    };

    this.handleUI = ::this.handleUI;
    this.handleChange = ::this.handleChange;

  }



  componentDidMount() {
    this.props.dispatch(syncActions.setNavState({isOpen: false, hideClose: false}));

    if (isEmpty(this.state.company) && !isEmpty(this.props.company)) {
      this.setState(merge({}, this.state, {company: this.props.company}));
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.company) {
      this.setState(merge({}, this.state, {company: nextProps.company}));
    }
  }

  handleUI(prop, label) {

    let result = {
      'data-id': prop,
      defaultValue: this.state.newContactModel[prop],
      floatingLabelText: label,
      isDirty: this.state.isDirty,
      errorText: (this.state.isDirty) ? validateField(this.state.newContactModel[prop], this.addNewContactModel[prop])[0] : undefined,
      onErrorChange: (this.state.isDirty) ? validateField(this.state.newContactModel[prop], this.addNewContactModel[prop])[0] : undefined,
      onBlur: this.handleChange(prop),
    };

    const extraFields = {};
    if (prop === 'state') {
      extraFields.validation = this.addNewContactModel[prop];
      result = omit(result, ['onErrorChange']);
    }

    return {...result, ...extraFields};
  }
  handleChange(prop) {
    return (event, value) => {
      const newContact = this.state.newContactModel;
      newContact[prop] = value;
      this.setState(merge({}, this.state, {newContactModel: newContact}));
    };
  }
  closeModal() {
    this.setState(merge(this.state, {showModal: false}), () => {
        if(this.state.modalMessage === 'Contact has been successfully created.') {
          this.props.dispatch(push('/client/company'));
        }

    });
  }
  handleSubmit = () => {

    const errors = validate(this.state.newContactModel, this.addNewContactModel);
      if (errors.length > 0) {
        this.setState({isDirty: true});
      } else {
        const newContact = {
          user: pick(this.state.newContactModel, ['firstName', 'lastName', 'email', 'phoneNumber1', 'address', 'city', 'state', 'zip']),
          profile: pick(this.state.newContactModel, ['companyId', 'title', 'types'])
        };
        this.props.dispatch(companyApi.addCompanyContacts(newContact, (err, contact) => {
          if(err) {
            console.log('error', err);
            if(err.errors[0].errorMessage === 'User with that email already exists.') {
              this.setState(merge({}, this.state, {modalMessage: 'The contact you are trying to add already exists in your company\'s contacts list. Click on your Company name to access your company\'s record.', showModal: true}));
            }else {
              this.setState(merge({}, this.state, {modalMessage: err.errors[0].message, showModal: true}));
            }
          } else {
            this.setState(merge({}, this.state, {modalMessage: 'Contact has been successfully created.', showModal: true}));
            this.props.dispatch(updateCompanyContacts([...this.props.companyContacts, contact]));
          }
      }));
    }
  }

  render() {
    let yesNoItems = [
      {
        primaryText :'Yes',
        subElement :null,
        value :true
      },		{
        primaryText :'No',
        subElement :null,
        value :false
      }
    ];
    const {
      stateList,
      } = this.props.staticData;

    return (
      <div className='create-company-contact application-form'>
        <ScrollColumn
          navGroups={['Contact_Info']}
          title={'Add New'}
        />
        {
          !!this.state.showModal &&
          <InfoModal
            cancelFunc={this.closeModal.bind(this)}
            buttonLabel='close'
            transitionFunc={this.closeModal.bind(this)}
            text={this.state.modalMessage}
          />
        }

      <div>
        <section id='Contact_Info'>
          <h1>
            Contact Information
          </h1>
          <div className='form-section-content clearfix'>
            <div className='box-container-fixed clearfix'>
              <div className='box'>
                <TextField
                  {...this.handleUI('firstName', 'First Name')}/>
              </div>
              <div className='box'>
                <TextField
                  {...this.handleUI('lastName', 'Last Name')}/>
              </div>
              <div className='box'>
                <TextField
                  {...this.handleUI('title', "Contact's Title")}/>
              </div>
              <div className='box'>
                <TextField
                  {...this.handleUI('email', 'Email Address')}/>
              </div>
              <div className='box'>
                <MaskedTextField
                  hideMaskChar
                  mask='(999) 999-9999'
                  {...this.handleUI('phoneNumber1', 'Phone Number')}/>
              </div>
              <div className='box'>
                <TextField
                  {...this.handleUI('address', 'Street Address')}/>
                </div>
              <div className='box'>
                <TextField
                  {...this.handleUI('city', 'City')}/>
                </div>
              <div className='box'>
                <SimpleDropDownMenu
                  menuItems={stateList}
                  underlineStyle={{margin: '-1px 0px'}}
                  iconStyle={{right: '0px', fill: 'rgb(33, 35, 38)'}}
                  labelStyle={{paddingLeft: '0px'}}
                  {...this.handleUI('state', 'State')}/>
                </div>
              <div className='box'>
                <TextField
                  type='number'
                  maxLength={5}
                  {...this.handleUI('zip', 'Zip')}/>
                </div>
            </div>
          </div>
        </section>
      </div>
      <ul className='bottom-bar'>
        <li className='continue-button'>
          <RaisedButton label='Create'
            onClick={this.handleSubmit}
          />
        </li>
      </ul>
    </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/client/CreateCompanyContact/index.js